import React from 'react'

import { setValue } from './common'

export const setDescriptionTwoLine = (description: string): JSX.Element => {
  return (
    <span className='tbody__cell-display-two-line'>
      {setValue(description)}
    </span>
  )
}

export const setDescriptionFullContent = (description: string): JSX.Element => {
  return (
    <span className='tbody__cell-display-all'>{setValue(description)}</span>
  )
}
